import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  makeStyles,
  LinearProgress
} from '@material-ui/core';

import { actions, CONSTANTS } from 'src/redux';
import Page from 'src/components/Page';
import ProfileDetails from './ProfileDetails';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const UsersEditView = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { editUsers } = useSelector((state) => state.users);

  useEffect(() => {
    if (
      editUsers.status === CONSTANTS.STATUS.DONE
      && editUsers.type === 'USERS::UPDATE_USER'
    ) {
      dispatch(actions.users.editUsers.redirect());
      navigate('/app/users');
    }
  }, [editUsers]);

  useEffect(() => {
    if (id !== editUsers.user._id) dispatch(actions.users.editUsers.get(id));
  }, [id]);

  return (
    <Page className={classes.root} title="UsersEditView">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} xs={12}>
            {editUsers.status === CONSTANTS.STATUS.DONE && editUsers.type !== 'USERS::UPDATE_USER_REDIRECT' ? (
              <ProfileDetails user={editUsers.user} />
            ) : (
              <LinearProgress />
            )}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default UsersEditView;
